// @ts-nocheck
import React from 'react';
import config from '@@/dumi/config';
import demos from '@@/dumi/demos';
import apis from '@@/dumi/apis';
import Layout from '/home/johan/jingqb/jingui/node_modules/.pnpm/@umijs+preset-dumi@1.1.50_33ra76l5kwdattnfxf73xw7yo4/node_modules/@umijs/preset-dumi/lib/theme/layout';

export default (props) => <Layout {...props} config={config} demos={demos} apis={apis} />;
